import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChatCircleText } from "@phosphor-icons/react";

export default function FloatingCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href="#quote"
          data-testid="floating-cta"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#D4AF37] text-[#050505] font-bold text-sm uppercase tracking-wider px-5 py-4 shadow-[0_10px_40px_rgba(212,175,55,0.35)] hover:bg-[#B8860B] transition-colors"
        >
          <ChatCircleText size={18} weight="bold" />
          Get a Quote
        </motion.a>
      )}
    </AnimatePresence>
  );
}
